import { ReactNode } from "react";
import Container from "./Container";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

export default function PageContainer({ children, className = "" }: PageContainerProps) {
  return (
    <Container 
      className={`
        pb-10 md:pb-10
        ${className}
      `}
    >
      {children}
    </Container>
  );
}